<template>
  <div class>
    <div class="row d-none d-lg-block">
      <div class="col-12">
        <div class="d-flex justify-content-start align-items-center">
          <i class="favourite-icon material-icons -title mt-1 mr-2">star</i>
          <h5 class="mt-4 mb-3">Favourite Scenarios</h5>
        </div>
        <p class="text-center no-favourites" v-show="favouritedScenarios.length == 0 && !isLoading">
          Use the
          <i class="material-icons">star_border</i> to favourite
          some scenarios!
        </p>
        <ol class="favourite-scenarios list-group mb-3">
          <li
            v-bind:key="favourite.scenario.uuid_id"
            v-bind:class="{ active: favourite.scenario.uuid_id == viewingScenarioId }"
            class="list-group-item mb-3 bg-light"
            v-for="favourite in favouritedScenarios"
          >
            <FavouriteScenario
              :uuidId="favourite.scenario.uuid_id"
              :deviceId="favourite.scenario.device_id"
              :name="favourite.scenario.name"
              :contributedBy="favourite.scenario.contributed_by.is_public ? favourite.scenario.contributed_by.publicUsername : 'Anonymous User'"
            ></FavouriteScenario>
          </li>
        </ol>
      </div>
    </div>
    <div class="btn-group d-block d-lg-none">
      <div id="accordion">
        <div class="card mt-2">
          <button
            id
            class="card-header btn btn-primary d-flex py-3 rounded"
            data-toggle="collapse"
            data-target="#favouriteScenarios"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="material-icons" style="margin-right:7px">star</i>
            <span>Favourite Scenarios</span>
          </button>

          <div
            id="favouriteScenarios"
            class="collapse"
            aria-labelledby="favouriteScenarios"
            data-parent="#favouriteScenarios"
          >
            <div class="card-body">
              <ul class="d-flex flex-column justify-content-center list-unstyled">
                <li v-show="favouritedScenarios.length == 0">
                  Use the
                  <i class="material-icons">star_border</i> to favourite
                  some scenarios!
                </li>
                <li class="list-group-item mb-3" v-for="favourite in favouritedScenarios">
                  <FavouriteScenario
                    :uuidId="favourite.scenario.uuid_id"
                    :deviceId="favourite.scenario.device_id"
                    :name="favourite.scenario.name"
                    :contributedBy="favourite.scenario.contributed_by.is_public ? favourite.scenario.contributed_by.publicUsername : 'Anonymous User'"
                  ></FavouriteScenario>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoggedInUser from "../components/LoggedInUser.vue";
import ScenService from "../services/scenarios.service";
import FavouriteScenario from "../components/FavouriteScenario";
import FavouriteScenariosList from "../components/FavouriteScenariosList";
import storage from "store";

export default {
  name: "FavouriteScenariosList",
  computed: {
    viewingScenarioId() {
      return this.$store.getters.getViewingScenarioId;
    },
    shouldHaveActiveClass: function(uuidId) {
      active: this.uuidId = viewingScenarioId;
    }
  },
  user() {
    return this.$store.getters.getUser;
  },
  data: function() {
    return {
      favouritedScenarios: [],
      isLoading: false
    };
  },
  methods: {
    setScenario() {
      this.$store.dispatch("setScenario");
    },
    getFavouritedScenarios() {
      this.isLoading = true;
      ScenService.favouritedScenarios().then(data => {
        this.favouritedScenarios = data;
        this.isLoading = false;
      });
    },
    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    }
  },
  watch: {
    testDcurrentScenarioata: {
      immediate: true,
      deep: false,
      handler(newValue, oldValue) {}
    }
  },

  beforeMount() {
    this.getFavouritedScenarios();
  },
  beforeUpdate() {},
  components: {
    LoggedInUser,
    FavouriteScenario,
    FavouriteScenariosList
  }
};
</script>

<style>
.list-group-item {
  border-radius: 0.25rem;
  padding: 0.75rem;
}
.favourite-scenarios .list-group-item {
  border: none;
}
.no-favourites {
  font-size: 15px;
  opacity: 0.5;
  text-align: center;
  font-style: italic;
  margin-left: 20px;
  margin-right: 20px;
}
.favourite-scenarios .list-group-item.active {
  border: 2px solid #7d7d7d;
}

.favourite-icon {
  font-size: 20px;
  color: #6c757d;
}
</style>
